import {
  Box,
  Container,
  Dialog,
  Stack,
  Tab,
  Tabs,
  useTheme
} from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import useOpenListCategoryModal from '../../../../hooks/ui-states/useOpenListCategoryModal';
import { useCategories } from '../../../../hooks/useCategories';
import MainAppBar from "../../../global/MainAppBar";
import CategoriesList from "../List";
import PlusIcon from "../../../ui/icons/PlusIcon";
import ConfirmDialog from "../../../ui/ConfirmDialog";
import { ROUTES } from "../../../../constants/routes";
import { useNavigate } from "react-router-dom";

const ModalCategoriesList = () => {
  const { t } = useTranslation('categories');
  const theme = useTheme();
  const navigate = useNavigate();
  const [openListCategory, setOpenListCategory] = useOpenListCategoryModal();
  const [openAddCategoryDialog, setOpenAddCategoryDialog] = useState(false);

  const [selectedTab, setSelectedTab] = useState<CategoryType>(openListCategory || 'expense');

  const { data: expenseCategories, isLoading: expenseLoading, error: expenseError } = useCategories('expense');
  const { data: incomeCategories, isLoading: incomeLoading, error: incomeError } = useCategories('income');

  const handleClose = () => {
    setOpenListCategory(null);
  };

  const handleTabChange = (event: React.SyntheticEvent, newValue: CategoryType) => {
    setSelectedTab(newValue);
  };

  const getCurrentCategories = (): Category[] => {
    if (selectedTab === 'expense') {
      return expenseCategories || [];
    }

    return incomeCategories?.reduce((acc: Category[], category) => {
      return [...acc, ...category.categories];
    }, [] as Category[]) || [];
  };

  const getCurrentLoading = (): boolean => {
    return selectedTab === 'expense' ? expenseLoading : incomeLoading;
  };

  const getCurrentError = (): Error | null => {
    return selectedTab === 'expense' ? expenseError : incomeError;
  };

  const handleOnAddCategory = () => {
    if (selectedTab === 'expense') {
      setOpenAddCategoryDialog(true);
      return;
    }
    return navigate({pathname: ROUTES.CATEGORIES, search: `?categoryGroupId=${incomeCategories?.[0]?.id}&type=${selectedTab}`});
  }

  useEffect(() => {
    setSelectedTab(openListCategory || 'expense');
  }, [openListCategory]);

  return (
    <Dialog
      fullScreen
      scroll="body"
      open={!!openListCategory}
      onClose={handleClose}
      sx={{
        '& .MuiDialog-paper': {
          overflow: 'hidden'
        },
      }}
    >
      <Box sx={{ height: '100%' }}>
        <MainAppBar
          preventGoBack
          elevation={1}
          beforeGoBack={handleClose}
          title={t('edit_category_page_title')}
          extraAction={
            <PlusIcon color="#475480" fontSize="30px" onClick={handleOnAddCategory} />
          }
          sx={{
            // boxShadow: theme.shadows[1],
            // backgroundColor: theme.palette.background.default,
            backgroundColor: theme.palette.common.white,
          }}
        />
        <Stack sx={{ height: 'calc(100% - 56px)', overflow: 'auto' }}>
          <Tabs
            value={selectedTab}
            variant="fullWidth"
            onChange={handleTabChange}
            sx={{
              borderBottom: 1,
              borderColor: 'divider',
              '& .MuiTab-root': {
                textTransform: 'none',
                fontWeight: 500,
              }
            }}
          >
            <Tab
              label={t('expense_categories', { ns: 'categories' })}
              value="expense"
            />
            <Tab
              label={t('income_categories', { ns: 'categories' })}
              value="income"
            />
          </Tabs>
          <Container>
            <CategoriesList
              type={selectedTab}
              error={getCurrentError()}
              isLoading={getCurrentLoading()}
              categories={getCurrentCategories()}
              divider={selectedTab === 'expense'}
            />
          </Container>
        </Stack>
      </Box>

      <ConfirmDialog
        open={openAddCategoryDialog}
        onClose={() => setOpenAddCategoryDialog(false)}
        title="Bạn muốn tạo gì?"
        buttons={[
          {
            label: "Nhóm chi",
            variant: "secondary",
            onClick: () => {
              setOpenAddCategoryDialog(false);
              navigate({pathname: ROUTES.CATEGORY_GROUP})
            },
          },
          {
            label: "Mục chi",
            variant: "primary",
            onClick: () => {
              navigate({pathname: ROUTES.CATEGORIES})
              setOpenAddCategoryDialog(false);
            },
          },
        ]}
      />
    </Dialog>
  )
}

export default ModalCategoriesList